//@flow
import * as React from 'react';
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import './Heading4.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const Heading4 = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("Heading4", props.addClasses)}>{props.children}</div>
  );
};

export default Heading4;